import axios from 'axios';
export default class MembershipService {
    fetchMembership() {
        let accessToken= sessionStorage.getItem('access_token');
        
        let payload={supplierRefId:process.env.VUE_APP_SUPPLIER_REF_ID};
        return axios.post(process.env.VUE_APP_API_ROOT+'/member/info',payload,{
                headers:{
                    'Authorization': 'Bearer '+accessToken
                }
            }
        ).then(res => res.data);
    }

    joinMembership() {
        let accessToken= sessionStorage.getItem('access_token');
        let payload={supplierRefId:process.env.VUE_APP_SUPPLIER_REF_ID};
        return axios.post(process.env.VUE_APP_API_ROOT+'/member/join',payload,{
                headers:{
                    'Authorization': 'Bearer '+accessToken
                }
            }
        ).then(res => res.data);
    }

    fetchMembershipRewardRate() {       
        return axios.get(process.env.VUE_APP_API_ROOT+'/member/default-reward-rate/'+process.env.VUE_APP_SUPPLIER_REF_ID
        ).then(res => res.data);
    }
}